export enum RouteNames {
  MAIN_PAGE = '',
  LOGIN_PAGE = 'login',
  FORBIDDEN_PAGE = 'forbidden',
  KANBAN_PAGE = 'kanban',
  HOME = 'home',
  NOMENCLATURE = 'nomenclature',
  USER = 'user',
  CATALOGS_PAGE = 'catalogs',
  RESET_PASSWORD_PAGE = 'reset-password',
  REGISTER_PAGE = 'register',
  CALCULATOR = 'calculator',
  CARGO_PAGE = 'cargo',
  CARGO_LOADING_PAGE = 'cargo/loading',
  CARGO_ON_THE_WAY_PAGE = 'cargo/on-the-way',
  PRE_ORDERS_PAGE = 'pre-orders',
  TOOLS = 'tools',
  ARCHIVE = 'archive',
  JOURNAL_PAGE = 'journal',
  REPORTS = 'reports',
  INVOICES_PAGE = 'invoices-and-specs',
}

export enum InvoicesRouteNames {
  PARSED_INVOICE = 'parsed-invoice',
  SPECIFICATION = 'specification',
  ACCOUNTING_INVOICE = 'accounting-invoice',
}
export enum OrganizationRouteNames {
  MAIN = 'organization',
  LIST = 'organization/list',
  DETAILS = 'organization/:id',
}

export enum ReportRouteNames {
  COMPLETED_WORK = 'completed-work',
  INVOICE_TO_PAID = 'invoice-to-paid',
}
